import { PlaceReport } from "../../../models";
import { DataProviderArgs } from "../../DataStore/DataProvider";
import { IPlaceReport } from "../../models/Models";
import { awsPlaceReportToSimplePlaceReport } from "../IPlaceTable";
import { GraphQLTable } from "./GraphQLTable";

export class PlaceReportTable extends GraphQLTable<IPlaceReport> {
    private _allByPlaceId = new Map<string, IPlaceReport[]>();

    constructor(args: DataProviderArgs) {
        super(
            args,
            [],
            {
                get: "getPlaceReport",
                list: "listPlaceReports",
                create: "createPlaceReport",
            },
            (obj: PlaceReport) => awsPlaceReportToSimplePlaceReport(obj)
        );
    }

    public override create(_props: any, ..._args: any[]): Promise<any> {
        return new Promise(() => false);
    }

    public async allByPlaceId(id: string, ..._args: any[]): Promise<IPlaceReport[] | undefined> {
        if (this._allByPlaceId.has(id)) {
            return this._allByPlaceId.get(id);
        }

        const items = Array.from(
            await this._allAux({
                placeReportsId: {
                    eq: id,
                },
            })
        );

        if (items) {
            //this._notifyListeners(new ChangeSet([item], [], []));
            this._allByPlaceId.set(id, items);
            return items;
        }
        return undefined;
    }
}
